if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        // Always call super.hide() to properly remove overflow-hidden from body
        // super.hide();
      }

      hideCustom() {
        // Alias for hide - ensures body overflow is removed
        this.hide();
      }

      show(opener) {
        // Check if this is the new modal structure (has .product-media-modal__content-wrapper)
        const newModalStructure = this.querySelector('.product-media-modal__content-wrapper');
        if (newModalStructure) {
          // New modal structure - call super.show first, then initialize
          super.show(opener);
          this.initializeNewModal(opener);
          return;
        }
        
        // Old modal structure - use original logic
        super.show(opener);
        this.showActiveMedia();
      }

      initializeNewModal(opener) {
        try {
          // Get section ID from modal ID
          const modalId = this.id;
          const sectionId = modalId.replace('ProductModal-', '');
          
          // Immediately hide any existing image and show loader
          const mainImageContainer = this.querySelector('.product-media-modal__main-image');
          const imageWrapper = mainImageContainer?.querySelector('.product-media-modal__image-wrapper');
          const loader = mainImageContainer?.querySelector('.product-media-modal__loader');
          
          if (imageWrapper) {
            imageWrapper.classList.remove('loaded');
            imageWrapper.innerHTML = ''; // Clear any initial content
          }
          if (loader) {
            loader.classList.remove('hidden');
          }
          
          // Get the media ID from the opener FIRST (before filtering)
          // The opener might be modal-opener, button, or the clicked element
          let mediaId = null;
          if (opener) {
            // Try to get from opener directly
            mediaId = opener.getAttribute('data-media-id');
            
            // If not found, try to find it in children (button or other elements)
            if (!mediaId) {
              const buttonWithMediaId = opener.querySelector('[data-media-id]');
              if (buttonWithMediaId) {
                mediaId = buttonWithMediaId.getAttribute('data-media-id');
              }
            }
            
            // Also check if opener is inside a modal-opener
            if (!mediaId && opener.closest) {
              const modalOpener = opener.closest('modal-opener');
              if (modalOpener) {
                const buttonInOpener = modalOpener.querySelector('[data-media-id]');
                if (buttonInOpener) {
                  mediaId = buttonInOpener.getAttribute('data-media-id');
                }
              }
            }
          }
          
          let actualMediaId = null;
          if (mediaId) {
            // Extract just the media ID (format might be "section-id-mediaId" or just the ID number)
            // Try parsing as integer first (if it's just a number)
            const parsed = parseInt(mediaId);
            if (!isNaN(parsed)) {
              actualMediaId = parsed;
            } else {
              // If it's a string format like "section-id-mediaId", get the last part
              const parts = mediaId.split('-');
              if (parts.length > 0) {
                const lastPart = parts[parts.length - 1];
                actualMediaId = parseInt(lastPart);
              }
            }
          }
          
          // Store the clicked media ID in the data object BEFORE filtering
          const dataKey = `productModal_${sectionId}`;
          const data = window.productModalData && window.productModalData[dataKey];
          if (data && actualMediaId) {
            data.clickedMediaId = actualMediaId; // Store for use during filtering
          }
          
          // Update modal with current variant images to filter correctly
          // Pass the clicked media ID so it can be preserved
          if (window.productModalHandlers && typeof window.productModalHandlers.updateModalOnOpen === 'function') {
            // Call immediately to filter before setting the image
            window.productModalHandlers.updateModalOnOpen(sectionId, actualMediaId);
          }
          
          // Update arrow visibility after modal opens
          setTimeout(() => {
            if (window.productModalHandlers && typeof window.productModalHandlers.updateArrowVisibility === 'function') {
              window.productModalHandlers.updateArrowVisibility(sectionId);
            }
          }, 100);
          
          // The filterByVariant function will now handle updating the image immediately
          // But we also have a fallback to ensure the clicked image shows
          if (actualMediaId && data) {
            // Fallback: If after filtering the clicked image isn't shown, find and show it
            setTimeout(() => {
              const mediaToUse = data.filteredMedia && data.filteredMedia.length > 0 ? 
                                data.filteredMedia : data.productMedia;
              const clickedIndex = mediaToUse.findIndex(m => m.id === actualMediaId);
              
              // Only update if current index doesn't match the clicked image
              if (clickedIndex !== -1 && data.currentMediaIndex !== clickedIndex) {
                data.currentMediaIndex = clickedIndex;
                if (window.productModalHandlers && typeof window.productModalHandlers.updateMainImage === 'function') {
                  window.productModalHandlers.updateMainImage(sectionId);
                }
              }
            }, 200);
          } else if (!actualMediaId && data) {
            // If no clicked media ID, wait a bit and update to first filtered image
            setTimeout(() => {
              if (data.filteredMedia && data.filteredMedia.length > 0) {
                data.currentMediaIndex = 0;
                if (window.productModalHandlers && typeof window.productModalHandlers.updateMainImage === 'function') {
                  window.productModalHandlers.updateMainImage(sectionId);
                }
              }
            }, 150);
          }
        } catch (e) {
          console.log('Error initializing new modal:', e);
        }
      }

      showActiveMedia() {
        // Old modal structure - use original logic
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        // activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
